import { IntlProvider } from "react-intl";
import { styles } from "../../reportingHelpers.jsx";
import { Document, Page } from "@react-pdf/renderer";
import MatchInfo from "../MatchInfo.jsx";
import React from "react";
import SeasonHeader from "../SeasonHeader.jsx";
import TeamsAndScores from "../TeamsAndScores.jsx";
import { processScoringIntervals } from "../helpers.js";
import TeamShootoutScoring from "./TeamShootoutScoring.jsx";
import TeamShootoutDefenders from "./TeamShootoutDefenders.jsx";
import FinalResult from "./FinalResult.jsx";
import ShootoutOfficials from "./ShootoutOfficials.jsx";

const ShootoutReport = ({ data, intl, locale }) => {
  const { fixture, playByPlay, roles, scoringIntervals, teams } = data;
  const homeTeamId = Object.keys(teams).find((id) => teams[id].isHome);
  const awayTeamId = Object.keys(teams).find((id) => !teams[id].isHome);
  const intervals = processScoringIntervals(
    scoringIntervals,
    homeTeamId,
    awayTeamId
  );

  return (
    <IntlProvider locale={locale ?? "en-US"}>
      <Document>
        <Page
          size="A4"
          orientation="portrait"
          style={{ ...styles.page, fontFamily: ["Noto Sans", "Noto Sans TC"] }}
          wrap={false}
        >
          <SeasonHeader fixture={fixture}/>

          <MatchInfo intl={intl} fixture={fixture} matchLabel="reports.shootoutReport"/>

          <TeamsAndScores
            intl={intl}
            scoringIntervals={intervals}
            teams={teams}
            playByPlay={playByPlay}
            showShootout
          />

          <TeamShootoutScoring
            intl={intl}
            playByPlay={playByPlay}
            teams={teams}
            homeTeamId={homeTeamId}
            awayTeamId={awayTeamId}
          />

          <TeamShootoutDefenders
            intl={intl}
            playByPlay={playByPlay}
            teams={teams}
            homeTeamId={homeTeamId}
            awayTeamId={awayTeamId}
          />

          <FinalResult
            intl={intl}
            pbp={playByPlay}
            homeTeamId={homeTeamId}
            awayTeamId={awayTeamId}
          />

          <ShootoutOfficials
            roles={roles}
            homeTeamId={homeTeamId}
            awayTeamId={awayTeamId}
          />
        </Page>
      </Document>
    </IntlProvider>
  );
};

export default ShootoutReport;
